import React, { PureComponent } from 'react';

import SvgError from '../../../../assets/svgs/error.svg';
import classNames from 'classnames/bind';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);
class ErrorText extends PureComponent {
  render() {
    const { children } = this.props;
    return (
      <p className={cx('ErrorText', 'body2')} {...this.props}>
        <SvgError />
        {children}
      </p>
    );
  }
}

export default ErrorText;
